/*
This file was created by the script build.py 
*/

import {getAllFiltered} from "./filter";
import {searchObjectFurtherSearchCategorisation} from "./searchObjects"



export function fillSearchObjectFurtherSearchCategorisation(){
    searchObjectFurtherSearchCategorisation.categories = [];
    searchObjectFurtherSearchCategorisation.keywords = [];

    const checkbox = document.getElementById("categoryFurtherSearchCategorisation");
    if(checkbox.checked || checkbox.indeterminate){
        searchObjectFurtherSearchCategorisation.categories.push(checkbox.value);
    }

    const anyButton = document.getElementById("buttonFurtherSearchCategorisationAny");
    if(anyButton.classList.contains("chosen")){
        searchObjectFurtherSearchCategorisation.any = true;
    }

    const allButton = document.getElementById("buttonFurtherSearchCategorisationAll");
    if(allButton.classList.contains("chosen")){
        searchObjectFurtherSearchCategorisation.any = false;
    }
    
    const buttonAdditionalHiggsbosons = document.getElementById("buttonFurtherSearchCategorisationAdditionalHiggsbosons");
    if(buttonAdditionalHiggsbosons.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonAdditionalHiggsbosons.value)
    }
    
    const buttonCompositeness = document.getElementById("buttonFurtherSearchCategorisationCompositeness");
    if(buttonCompositeness.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonCompositeness.value)
    }
    
    const buttonContactInteractions = document.getElementById("buttonFurtherSearchCategorisationContactInteractions");
    if(buttonContactInteractions.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonContactInteractions.value)
    }
    
    const buttonDarkMatterDarksector = document.getElementById("buttonFurtherSearchCategorisationDarkMatterDarksector");
    if(buttonDarkMatterDarksector.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonDarkMatterDarksector.value)
    }
    
    const buttonExcitedfermions = document.getElementById("buttonFurtherSearchCategorisationExcitedfermions");
    if(buttonExcitedfermions.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonExcitedfermions.value)
    }
    
    const buttonExtraDimensions = document.getElementById("buttonFurtherSearchCategorisationExtraDimensions");
    if(buttonExtraDimensions.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonExtraDimensions.value)
    }
    
    const buttonHeavyadditionalfermions = document.getElementById("buttonFurtherSearchCategorisationHeavyadditionalfermions");
    if(buttonHeavyadditionalfermions.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonHeavyadditionalfermions.value)
    }
    
    const buttonLeptonflavourviolation = document.getElementById("buttonFurtherSearchCategorisationLeptonflavourviolation");
    if(buttonLeptonflavourviolation.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonLeptonflavourviolation.value)
    }
    
    const buttonLeptoquarks = document.getElementById("buttonFurtherSearchCategorisationLeptoquarks");
    if(buttonLeptoquarks.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonLeptoquarks.value)
    }
    
    const buttonLongLivedparticles = document.getElementById("buttonFurtherSearchCategorisationLongLivedparticles");
    if(buttonLongLivedparticles.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonLongLivedparticles.value)
    }
    
    const buttonNewResonances = document.getElementById("buttonFurtherSearchCategorisationNewResonances");
    if(buttonNewResonances.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonNewResonances.value)
    }
    
    const buttonSupersymmetry = document.getElementById("buttonFurtherSearchCategorisationSupersymmetry");
    if(buttonSupersymmetry.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonSupersymmetry.value)
    }
    
    const buttonSupersymmetryCharginosNeutralinosWinosHiggsinos = document.getElementById("buttonFurtherSearchCategorisationSupersymmetryCharginosNeutralinosWinosHiggsinos");
    if(buttonSupersymmetryCharginosNeutralinosWinosHiggsinos.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonSupersymmetryCharginosNeutralinosWinosHiggsinos.value)
    }
    
    const buttonSupersymmetryGMSB = document.getElementById("buttonFurtherSearchCategorisationSupersymmetryGMSB");
    if(buttonSupersymmetryGMSB.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonSupersymmetryGMSB.value)
    }
    
    const buttonSupersymmetryRPV = document.getElementById("buttonFurtherSearchCategorisationSupersymmetryRPV");
    if(buttonSupersymmetryRPV.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonSupersymmetryRPV.value)
    }
    
    const buttonSupersymmetrySleptons = document.getElementById("buttonFurtherSearchCategorisationSupersymmetrySleptons");
    if(buttonSupersymmetrySleptons.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonSupersymmetrySleptons.value)
    }
    
    const buttonSupersymmetrySquarksandgluinos = document.getElementById("buttonFurtherSearchCategorisationSupersymmetrySquarksandgluinos");
    if(buttonSupersymmetrySquarksandgluinos.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonSupersymmetrySquarksandgluinos.value)
    }
    
    const buttonSupersymmetryStopsandsbottoms = document.getElementById("buttonFurtherSearchCategorisationSupersymmetryStopsandsbottoms");
    if(buttonSupersymmetryStopsandsbottoms.classList.contains('selected')){
        searchObjectFurtherSearchCategorisation.keywords.push(buttonSupersymmetryStopsandsbottoms.value)
    }
    
    getAllFiltered()

}